module.exports = __webpack_public_path__ + "img/bg-profile.9393ad46.png";